import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';
import { inaDir, isVideo, getExtension, getMineType, deleteImagesAsync } from '../components/media/MediaSelector';
import * as Device from 'expo-device';
import * as Sentry from '@sentry/react-native';
import { produce } from "immer"
import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
    addSync,
    changeState,
    doneSync,
    imageLoad,
    receiveJson,
    setOnline,
    startRequest,
    startSync,
    transmitError
} from "./mainSlice";

const processResponse = (response, usage, endpoint, begTime) => {
    console.log('RECV', usage, endpoint, (Date.now() - begTime) + 'ms')
    // showResponse(response)
    if (response.ok) {
        if (response.status == 204) {
            return Promise.resolve([])
        } else {
            if (usage.startsWith('TEXT_')) {
                return response.text() 
            } else {
                return response.json()
            }
        }
    } else {
        return response.text()
        // throw new Error(response.status)
    }
}

const showResponse = (response) => {
    Object.keys(response).forEach(key => console.log('RESPONSE', key + "=" + (!key.startsWith('_') ? response[key] : '?')))
    if (response && response.headers.map) {
        console.log("HEADERS")
        Object.keys(response.headers.map).forEach(key => console.log('HEADER', key + "=>" + (!key.startsWith('_') ? response.headers.map[key] : '?')))
    }
}

const filteredResponse = (response) => {
    const res = {}
    Object.keys(response).filter(key => !key.startsWith('_') && key != 'headers').forEach(key => res[key] = response[key])
    if (response && response.headers.map) {
        res.headers = {}
        Object.keys(response.headers.map).filter(key => !key.startsWith('_')).forEach(key => res.headers[key] = response.headers.map[key])
    }
    return res
}

const createRequest = (json, method) => {
    method = method || 'GET'
    let request = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    if (json) {
        request.body = typeof json == 'object' ? JSON.stringify(json) : json
    }
    return request
}

const updateMedia = (media, overlays, updates) => {
    for (let m = 0; m < media.length; m++) {
        if (updates[media[m]]) {
            const update = updates[media[m]] + (isVideo(media[m]) ? '.' + getExtension(media[m]) : '')
            const mediaId = media[m].replace('file://', '')
            if (overlays && overlays[mediaId]) {
                overlays[update] = overlays[mediaId]
                delete overlays[mediaId]
            }
            media[m] = update
        }
    }
}

// TODO: backendSync is currently implemented executing a single request with a 10 seconds re-check loop
export const backendSync = () => (dispatch, getState) => {
    const begTime = Date.now()
    const server = getState().server
    const remote = getState().remote
    if (server.sync.length > 0) {
        if (remote.active || remote.syncActive) {
            console.log('SYNC WAIT', server.sync.length, remote.active, remote.syncActive)
        } else {
            if (server.token?.value) {
                dispatch(backendRequest('TOKEN_LOGIN', '/login/token', server.token.value, 'POST')).then(async result => {
                    if (result) {
                        // this processes all syncs in sequence - including those added while sync is running!!!
                        dispatch(startSync())
                        for (const syncReq of server.sync) {
                            await execSync(syncReq, dispatch);
                        }
                        dispatch(doneSync({ done: server.sync.map(sync => sync.id) }))
                    }
                })
            } else {
                // missing token can only be fixed by re-login, set offline to prevent further errors
                dispatch(setOnline({status: false}))
            }
        }
    }
}

async function execSync(syncReq, dispatch) {
    console.ina('SYNC RUN', syncReq.usage, syncReq.data.endpoint);
    // console.log('TL', result)
    switch (syncReq.usage) {
        case 'SYNC_IMAGE_AVATAR':
            await dispatch(saveImageAsync(syncReq.usage, syncReq.data.endpoint, syncReq.data));
            break;
        case 'SYNC_IMAGES_LIST':
            await dispatch(backendLazyLoad(syncReq.data.batch));
            break;
        case 'SYNC_WF_CREATE':
            console.log(syncReq.usage, syncReq.data.endpoint);
            await createWorkflow(syncReq, dispatch)
            break;
        case 'SYNC_WF_UPDATE':
            // TODO: variante B
            await updateWorkflow(syncReq, JSON.parse(syncReq.data.json.workflowData), dispatch);
            break;
        case 'SYNC_WF_IMPORT':
            await dispatch(backendRequest(syncReq.usage, syncReq.data.endpoint, syncReq.data.json, 'PUT'));
            break;
        default:
            // 'SYNC_WF_DELETE', 'SYNC_REPORT_WF', 'SYNC_CONTACTS', 'SYNC_PLAN'
            // via syncAllowed: 'SYNC_IMAGE_PUBLIC', 'SYNC_UPDATE_USER'
            await dispatch(backendRequest(syncReq.usage, syncReq.data.endpoint, syncReq.data.json, syncReq.data.method));
            break;
    }
    console.log('SYNC RDY', syncReq.usage, syncReq.data.endpoint)
}

// Just make the async request here, and return the response. This will automatically dispatch a `pending` action first, and then `fulfilled` or `rejected` actions based on the promise.
export const saveSettings = createAsyncThunk('user/settings', async (updates, { dispatch, getState }) => {
    console.log('TTT', getState().settings, updates)
    const result = await dispatch(backendRequest('SETTINGS', '/user', { settings: JSON.stringify({ ...getState().settings, ...updates }) }, 'PUT', true))
    return result
})

export const processWorkflow = (task) => (dispatch, getState) => {
    const collectMedia = (workflow) => {
        let media = [...workflow.media]
        workflow.steps.forEach(step => {
            media = media.concat(step.media)
            if (step.check) {
                step.check.forEach(item => {
                    media = media.concat(item.media)
                })
            }
        })
        return media
    }

    const workflowDiff = (wOld, wNew) => {
        const mediaNew = collectMedia(wNew)
        if (wOld == undefined) {
            return { isChanged: true, isNew: true, mediaAdd: mediaNew, mediaDel: [] }
        }

        const mediaOld = collectMedia(wOld)
        const mediaDel = mediaOld.filter(file => !mediaNew.includes(file))
        const mediaLocal = mediaNew.filter(file => file.startsWith('file://'));

        if (wOld.workflowId == undefined) {
            // update of a workflow not yet synced
            return { isChanged: true, isNew: true, mediaAdd: mediaLocal, mediaDel: mediaDel }
        }

        let isChanged = mediaNew.filter(file => !mediaOld.includes(file)).length > 0 || mediaDel.length > 0 || JSON.stringify(wOld) != JSON.stringify(wNew)

        return { isChanged: isChanged, isNew: false, mediaAdd: mediaLocal, mediaDel: mediaDel }
    }

    if (task.simulatorPreview === true || task.id.length == 1) {
        dispatch(changeState({changes: { workflows: { ...getState().workflows, [task.id]: task } }}))
        return
    }
    let updates = workflowDiff(getState().workflows[task.id], task)
    console.log('UPDATES', updates)
    if (!updates.isChanged) {
        console.log('WF unchanged', task.id)
        return
    }
    // TODO: check locking
    task.locked = true
    // cleanup unused local images
    deleteImagesAsync(updates.mediaDel)
    // let changed = getState().settings.changed ? [...getState().settings.changed] : []
    // let hasChanges = false
    // if (!changed.includes(task.id)) {
    //     changed.push(task.id)
    //     hasChanges = true
    // }
    const online = getState().server.online
    if (updates.isNew) {
        task.version = getState().version
        const req = {
            usage: 'WF_CREATE', data: {
                endpoint: '/workflow',
                json: {
                    name: task.title,
                    description: task.text,
                    workflowData: JSON.stringify(task)
                },
                method: 'POST',
                mediaAdd: updates.mediaAdd,
                taskid: task.id,
                workflowId: task.workflowId
            }
        }
        if (online) {
            createWorkflow(req, dispatch);
        } else {
            // store for later processing
            dispatch(addSync({
                usage: 'SYNC_' + req.usage,
                data: req.data
            }))
        }
    } else {
        const req = {
            usage: 'WF_UPDATE', data: {
                endpoint: '/workflow/' + task.workflowId,
                json: {
                    name: task.title,
                    description: task.text,
                    workflowData: JSON.stringify(task)
                },
                method: 'PUT',
                mediaAdd: updates.mediaAdd,
                taskid: task.id,
                workflowId: task.workflowId
            }
        }
        if (online) {
            updateWorkflow(req, task, dispatch);
        } else {
            // store for later processing
            dispatch(addSync({
                usage: 'SYNC_' + req.usage,
                data: req.data
            }))
        }
    }
    let newState = {
        workflows: { ...getState().workflows, [task.id]: task },
    }
    // if (hasChanges) {
    //     newState.settings = { ...getState().settings, changed: changed }
    //     console.log('CHANGED', newState.settings)
    //     newState.notify = { ...getState().notify, tasklist: true }
    // }
    dispatch(changeState({changes: newState}))
}

const updateWorkflowParallel = async (syncReq, workflow, dispatch) => {
    const promises = syncReq.data.mediaAdd.map(uri => dispatch(saveImageAsync('SYNR_WF_IMAGE', '/workflow/' + workflow.workflowId + '/media', { uri: uri, title: syncReq.data.json.name, description: syncReq.data.json.description })));
    return Promise.all(promises).then(results => {
        const updates = {};
        results.filter(result => result).forEach(json => updates[inaDir + json.originalFilename] = json.id);
        console.log("RESULTS", results, updates);
        updateMedia(workflow.media, workflow.overlays, updates);
        workflow.steps.forEach(step => {
            updateMedia(step.media, step.overlays, updates);
            if (step.check) {
                step.check.forEach(item => {
                    updateMedia(item.media, item.overlays, updates);
                });
            }
        })
        syncReq.data.json.workflowData = JSON.stringify(workflow)
        return dispatch(backendRequest(syncReq.usage, syncReq.data.endpoint, syncReq.data.json, 'PUT'));
    });
}

const createWorkflow = async (syncReq, dispatch) => {
    const workflowR = await dispatch(backendRequest(syncReq.usage, syncReq.data.endpoint, syncReq.data.json, 'POST'))
    if (workflowR) {
        let workflow = JSON.parse(workflowR.workflowData)
        workflow.workflowId = workflowR.id
        const updReq = produce(syncReq, draftState => {
            draftState.usage = 'WF_UPDATE';
            draftState.data.endpoint += '/' + workflowR.id
        })
        await updateWorkflow(updReq, workflow, dispatch)
    }
}

const updateWorkflow = async (syncReq, workflow, dispatch) => {
    const workflowUpd = _.cloneDeep(workflow)
    const updates = {};
    let results = []
    if (Platform.OS === 'web') {
        results = await dispatch(backendRequest('SYNR_WF_IMAGE', '/studio/workflow/' + workflowUpd.studio.id + '/media-export', { tgtWorkflowId: workflowUpd.workflowId, mediaList: syncReq.data.mediaAdd.map(media => media.replace(/(file:\/\/)|(\..*)/g, '')) }, 'POST'));
        results.forEach((mediaId, idx) => {
            updates[syncReq.data.mediaAdd[idx]] = mediaId
        });
    } else {
        if (syncReq.data.mediaAdd) {
            for (const uri of syncReq.data.mediaAdd) {
                const result = await dispatch(saveImageAsync('SYNR_WF_IMAGE', '/workflow/' + workflowUpd.workflowId + '/media', { uri: uri, title: syncReq.data.json.name, description: syncReq.data.json.description }))
                results.push(result)
            }
        }
        results.filter(result => result).forEach(json => updates[inaDir + json.originalFilename] = json.id);
    }
    console.log("RESULTS", results, updates);
    updateMedia(workflowUpd.media, workflowUpd.overlays, updates);
    workflowUpd.steps.forEach(step => {
        updateMedia(step.media, step.overlays, updates);
        if (step.check) {
            step.check.forEach(item => {
                updateMedia(item.media, item.overlays, updates);
            });
        }
    })
    const updReq = produce(syncReq, draftState => {
        draftState.data.json.workflowData = JSON.stringify(workflowUpd)
    })
    return dispatch(backendRequest(updReq.usage, updReq.data.endpoint, updReq.data.json, 'PUT', true));
}

const backendRequestExecute = (usage, endpoint, json, method, server, dispatch) => {
    const begTime = Date.now()
    const data = createRequest(json, method)
    let res

    dispatch(startRequest({
        usage: usage,
        endpoint: endpoint,
        data: data,
        begTime: begTime
    }))
    return fetch(server.url + server.api + endpoint, data)
        .then(response => {
            res = response
            return processResponse(response, usage, endpoint, begTime)
        })
        .then(result => {
            if (res.ok) {
                console.log('JSON', usage, endpoint, (Date.now() - begTime) + 'ms')
                dispatch(receiveJson({
                    usage: usage,
                    endpoint: endpoint,
                    json: result,
                    response: filteredResponse(res),
                    begTime: begTime
                }))
            } else {
                dispatch(transmitError({
                    usage: usage,
                    endpoint: endpoint,
                    error: res.status,
                    message: result,
                    begTime: begTime
                }))
            }
            return result
        })
        .catch(error => {
            // console.log(error, Object.keys(error), typeof error) The string did not match the expected pattern.
            if (('' + error).endsWith('JSON Parse error: Unexpected end of input') || ('' + error).includes('Unexpected end of JSON input') || ('' + error).includes('The string did not match the expected pattern')) {
                // Empty JSON response => not an error
                dispatch(receiveJson({
                    usage: usage,
                    endpoint: endpoint,
                    json: null,
                    response: filteredResponse(res),
                    begTime: begTime
                }))
                return null
            } else {
                dispatch(transmitError({
                    usage: usage,
                    endpoint: endpoint,
                    error: 999,
                    message: '' + error,
                    begTime: begTime
                }))
                return null
            }
        })
}

export const backendRequest = (usage, endpoint, json, method, syncAllowed) => (dispatch, getState) => {
    const user = getState().user
    const noLogin = __DEV__ ? ['TOKEN_LOGIN', 'RESET_PW'].includes(usage) : ['ONLINE', 'TOKEN_LOGIN', 'RESET_PW'].includes(usage)
    if (user.demo && !noLogin) {
        console.log('DEMO', usage, endpoint)
    } else {
        const server = getState().server
        console.log('VALID?', server.online, noLogin, server.login ? Math.floor((Date.now() - server.login) / 60000) + 'min' : '0min')
        if (noLogin || server.online && server.login && Date.now() - server.login < 60 * 60000) {
            return backendRequestExecute(usage, endpoint, json, method, server, dispatch)
        } else {
            if (server.online && server?.token?.value) {
                return backendRequestExecute('TOKEN_LOGIN', '/login/token', server.token.value, 'POST', server, dispatch).then(() => {
                    return backendRequestExecute(usage, endpoint, json, method, server, dispatch)
                })
            } else {
                if (syncAllowed) {
                    // store for later processing
                    dispatch(addSync({
                        usage: 'SYNC_' + usage,
                        data: { endpoint: endpoint, json: json, method: method }
                    }))
                } else {
                    console.log('OFFLINE', usage)
                }
                return Promise.resolve(null)
            }
        }
    }
}

export const backendTokenLogin = (usage) => (dispatch, getState) => {
    const begTime = Date.now()
    const server = getState().server
    let endpoint = '/login/token'
    dispatch(backendRequest(usage, endpoint, server.token.value, 'POST'))
        .then(jsonResponse => {
            if (jsonResponse) {
                if (jsonResponse.userImage != null) {
                    loadImageAsync('/user/userImage', jsonResponse.id, true, dispatch, getState)
                }
            }
        })
}

export const backendLogin = (usage, user) => (dispatch, getState) => {
    const begTime = Date.now()
    const server = getState().server
    let res

    let endpoint, data, code
    if (typeof user == 'object') {
        console.log('USER', user.passwd, user.passwd.length)
        if (user.name == '' && user.passwd.length > 23) {
            if (user.passwd == '0yxqTYgfHQ0ASQnwoGXMokOmdI') {
                code = user.passwd
            } else {
                code = user.passwd.length == 26 ? user.passwd + '\r\n' : user.passwd
            }
            endpoint = '/login/token'
            data = createRequest(code, 'POST')
        } else {
            endpoint = '/login'
            data = createRequest({
                mail: (user.name.includes('@') ? user.name : user.name + '@ina.coach').toLowerCase(),
                password: user.passwd
            }, 'POST')
        }
    } else {
        code = user
        endpoint = '/login/token'
        data = createRequest(code, 'POST')
    }

    dispatch(startRequest({
        usage: usage,
        endpoint: endpoint,
        data: data,
        begTime: begTime
    }))
    fetch(server.url + server.api + endpoint, data)
        .then(response => {
            res = response
            return processResponse(response, usage, endpoint, begTime)
        })
        .then(result => {
            if (res.ok) {
                if (user == '0yxqTYgfHQ0ASQnwoGXMokOmdI@ina.coach') {
                    result.role = 'Admin'
                }
                console.log('JSON', usage, endpoint, (Date.now() - begTime) + 'ms')
                dispatch(receiveJson({
                    usage: usage,
                    endpoint: endpoint,
                    json: result,
                    response: filteredResponse(res),
                    begTime: begTime
                }))
                const server = getState().server
                if (!server.token || new Date(server.token.expiration + 'Z') < Date.now() + 24 * 60 * 60 * 1000) {
                    dispatch(backendRequest('TOKEN', '/user/token', {
                        type: 'APP',
                        description: result.preferredName + ';' + [Device.brand, Device.manufacturer, Device.osVersion, Device.osBuildId, Device.modelName, Device.modelId, Device.totalMemory].join(';') + ';v3.6'
                    }, 'POST'))
                }
                if (result.userImage != null) {
                    loadImageAsync('/user/userImage', result.id, true, dispatch, getState)
                }
            } else {
                dispatch(transmitError({
                    usage: usage,
                    endpoint: endpoint,
                    error: res.status,
                    message: result,
                    begTime: begTime
                }))
            }
            return result
        })
        .catch(error => {
            if (('' + error).endsWith('JSON Parse error: Unexpected end of input') || ('' + error).includes('Unexpected end of JSON input') || ('' + error).includes('The string did not match the expected pattern')) {
                // Empty JSON response => not an error
                dispatch(receiveJson({
                    usage: usage,
                    endpoint: endpoint,
                    json: [],
                    response: filteredResponse(res),
                    begTime: begTime
                }))
            } else {
                dispatch(transmitError({
                    usage: usage,
                    endpoint: endpoint,
                    error: 999,
                    message: '' + error,
                    begTime: begTime
                }))
            }
        })
}

export const backendUploadImage = (usage, endpoint, json, method, syncAllowed) => (dispatch, getState) => {
    const server = getState().server
    if (server.online) {
        return dispatch(saveImageAsync(usage, endpoint, json))
    } else {
        if (syncAllowed) {
            if (!usage.startsWith('SYNC_')) {
                // store for later processing
                dispatch(addSync({
                    usage: 'SYNC_' + usage,
                    data: { ...json, endpoint: endpoint, method: method }
                }))
            } else {
                console.log('SYNC offline?', usage, endpoint)
                Sentry.captureException(new Error('SYNC while offline: ' + usage + ', ' + endpoint))
            }
        }
    }
    return Promise.resolve(null)
}

// Upload the image using the FormData and fetch APIs
// Specifically on Android an image file without extension results in an exception:
// Error: URLConnection.guessContentTypeFromName(file.name) must not be null
// No combination of parms has solved that issue yet
export const saveImageAsync = (usage, endpoint, data) => async (dispatch, getState) => {
    const server = getState().server
    if (!server.online) {
        return Promise.resolve()
    }
    console.log(usage, endpoint, data.title, data.description, data.uri)
    if (Platform.OS === 'web') {
        const imageData = data.uri.split(",")
        const name = imageData[1].substring(0, 36)
        const mimetype = imageData[0].split(":")[1].split(";")[0]
        const res = await fetch(data.uri)
        const blob = await res.blob()
        const fd = new FormData();
        const file = new File([blob], "filename." + mimetype.split("/")[1]);
        fd.append('title', data.title)
        fd.append('description', data.description)
        fd.append('file', file)
        fd.append('mimetype', mimetype)
        const key = endpoint + '/' + name
        const begTime = Date.now()

        const headers = {
            'Accept': 'application/json'
        }

        // dispatch(startRequest(usage, key, data, begTime))
        return fetch(server.url + server.api + endpoint, { method: 'POST', headers: headers, body: fd }).then(async response => {
            console.log('RECV', key, (Date.now() - begTime) + 'ms')
            if (response.status >= 200 && response.status <= 299) {
                const json = await response.json()
                dispatch(receiveJson({
                    usage: usage,
                    endpoint: key,
                    json: json,
                    response: null,
                    begTime: begTime
                }))
                return json
            } else {
                console.log('RESPONSE', response)
                throw Error(response.status)
            }
        }).catch(error => {
            dispatch(transmitError({
                usage: usage,
                endpoint: key,
                error: 997,
                message: '' + error,
                begTime: begTime
            }))
        })
    } else {
        return FileSystem.getInfoAsync(data.uri).then(fileInfo => {
            const name = data.uri.substring(data.uri.lastIndexOf('/') + 1)
            const mimetype = getMineType(data.uri)
            const key = endpoint + '/' + name
            const begTime = Date.now()

            dispatch(startRequest({
                usage: usage,
                endpoint: key,
                data: data,
                begTime: begTime
            }))
            if (!fileInfo.exists) {
                console.log('Deleted?', data.uri)
                dispatch(transmitError({
                    usage: usage,
                    endpoint: key,
                    error: 998,
                    message: name,
                    begTime: begTime
                }))
                return Promise.resolve()
            }

            console.log('UPLOAD', data.uri, fileInfo)
            const headers = server.jwt && Platform.OS == 'android' ? {
                Accept: 'application/json',
                'Authorization': 'Bearer ' + server.jwt
            } : {
                Accept: 'application/json'
            }

            const parameters = usage.endsWith('IMAGE_SCREENSHOT') ? {
                title: data.title,
                description: data.description,
                mimetype: mimetype,
                data: data.data
            } : {
                title: data.title,
                description: data.description,
                mimetype: mimetype,
                originalfilename: name
            }
            return FileSystem.uploadAsync(
                server.url + server.api + endpoint,
                data.uri,
                {
                    httpMethod: 'POST',
                    headers: headers,
                    sessionType: FileSystem.FileSystemSessionType.BACKGROUND,
                    uploadType: FileSystem.FileSystemUploadType.MULTIPART,
                    fieldName: 'file',
                    parameters: parameters
                }).then(({ status, headers, body }) => {
                    console.log('RECV', key, (Date.now() - begTime) + 'ms')
                    if (status >= 200 && status <= 299) {
                        const json = JSON.parse(body)
                        // rename local file to remote id
                        let tgtUri = inaDir + (usage.endsWith('IMAGE_AVATAR') ? json.createdBy.id : (usage == 'UPDATE_IMAGE_INLINE' ? json.result.id : json.id))
                        if (isVideo(data.uri)) {
                            tgtUri += '.' + getExtension(data.uri)
                        }
                        if (Platform.OS == 'ios' && usage.endsWith('IMAGE_AVATAR')) {
                            tgtUri += '.png'
                        }
                        if (usage.endsWith('IMAGE_SCREENSHOT')) {
                            console.log('DELETE', data.uri)
                            try {
                                FileSystem.deleteAsync(data.uri)
                            } catch (error) {
                                console.log('Error: ' + error)
                            }
                        } else {
                            if (data.uri != tgtUri) {
                                console.log('MOVE', data.uri, tgtUri)
                                try {
                                    FileSystem.moveAsync({ from: data.uri, to: tgtUri })
                                } catch (error) {
                                    FileSystem.getInfoAsync(data.uri).then(fileInfo => {
                                        console.log('EXIST?', data.uri, fileInfo)
                                        Sentry.captureException(error);
                                    })
                                    // dispatch(transmitError({
                                    //     usage: usage,
                                    //     endpoint: key,
                                    //     error: 998,
                                    //     message: name,
                                    //     begTime: begTime
                                    // }))
                                }
                            }
                        }
                        dispatch(receiveJson({
                            usage: usage,
                            endpoint: key,
                            json: json,
                            response: null,
                            begTime: begTime
                        }))
                        return json
                    } else {
                        console.log('BODY', body)
                        throw Error(status)
                    }
                }).catch(error => {
                    dispatch(transmitError({
                        usage: usage,
                        endpoint: key,
                        error: 997,
                        message: '' + error,
                        begTime: begTime
                    }))
                })
        })
    }
}

export const backendSyncImage = (endpoint, id) => (dispatch, getState) => {
    return loadImageAsync(endpoint, id, false, dispatch, getState)
}

export const backendLazyLoad = (batch) => async (dispatch, getState) => {
    if (Platform.OS === 'web') {
        return
    }
    const images = getState().images
    const begTime = Date.now()
    const imagesLoad = images.list
    for (const imgId of imagesLoad) {
        if (Date.now() - begTime < 20000) {
            if (images.avatar.includes(imgId)) {
                await loadImageAsync('/contact/media/' + imgId, imgId, true, dispatch, getState)
            } else {
                await loadImageAsync('/workflow/media/' + imgId, imgId, false, dispatch, getState)
            }
        }
    }
}

const loadImageAsync = async (imgUri, imgId, overwrite, dispatch, getState) => {
    let filename = imgId
    if (Platform.OS == 'ios' && getExtension(filename) == '') {
        // in SDK50 or gluestack? there is automatically .png added on <Image component sources without extension => file not found, if we store to filesystem without extension 🤪
        filename += '.png'
    }
    if (Platform.OS === 'web') {
        return Promise.resolve(filename)
    }
    if (filename.startsWith('file://')) {
        console.log('LOCAL IMAGE', imgUri, imgId)
        return Promise.resolve(filename)
    }
    const begTime = Date.now()
    const server = getState().server
    const fileInfo = await FileSystem.getInfoAsync(inaDir + filename)
    if (fileInfo.exists && !(overwrite && server.online)) {
        return Promise.resolve(filename)
    } else {
        if (!server.online) {
            return Promise.resolve(filename)
        }
        // remove extension, if exists (for videos, jpg, jpeg, ...)
        imgUri = imgUri.replace(/\..{1,4}$/, '')
        const image = getState().images.load[imgId]
        // retry after 5 minutes - assume last load got timeout
        if (image && image.status < 0 && Date.now() - image.begTime < 5 * 60000) {
            console.log('Already loading:', imgUri, image, Date.now() - image.begTime)
            return Promise.resolve(filename)
        }
        if (image && (image.status == '404' || image.status == '500')) {
            console.log('NOTEXIST', imgUri, image, Date.now() - image.begTime)
            return Promise.resolve(filename)
        }
        dispatch(imageLoad({ uri: imgId, status:  -1 }))
        const options = {
            headers: server.jwt && Platform.OS == 'android' ? {
                'Authorization': 'Bearer ' + server.jwt
            } : {}
        }
        return FileSystem.downloadAsync(
            server.url + server.api + imgUri,
            inaDir + filename,
            options
        ).then(async ({ uri, status, headers }) => {
            if (status == 200) {
                dispatch(imageLoad({ uri: imgId, status: 200 }))
                return filename
            } else {
                try {
                    FileSystem.deleteAsync(inaDir + filename)
                } catch (error) {
                    console.log('DELETE ' + error)
                }
                dispatch(imageLoad({ uri: imgId, status: status} ))
                console.log('ERROR', imgUri, (Date.now() - begTime) + 'ms', status, headers, getState().images.load[imgId]);
                return null
            }
        }).catch(error => {
            console.error('ERROR', error)
            dispatch(imageLoad({ uri: imgId, status: 999 }))
            return null
        })
    }
}
